// extracted by mini-css-extract-plugin
module.exports = {"checkboxItem":"checkbox_checkboxItem__IQEhk","checkbox":"checkbox_checkbox__hyb9Z"};